import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
var envConfig = {
  source: 501
};
envConfig[window.feConfig.apiEnv] = {
  core: window.feConfig.common.apiBaseUrl + "core/",
  media: window.feConfig.common.media,
  orgInit: window.feConfig.common.apiBaseUrl + "orginit/",
  globalApi: window.feConfig.common.scApiBaseUrl + "misc/"
};
export var envApis = Object.keys(envConfig[window.feConfig.apiEnv]);
export var config = envConfig;
export function getNewConfig(_x) {
  return _getNewConfig.apply(this, arguments);
}

function _getNewConfig() {
  _getNewConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(env) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            return _context.abrupt("return", false);

          case 4:
            _context.prev = 4;
            _context.t0 = _context["catch"](0);
            console.error('getNewConfig error:', _context.t0);

          case 7:
            return _context.abrupt("return", false);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 4]]);
  }));
  return _getNewConfig.apply(this, arguments);
}

export function useNewDomain(_x2, _x3) {
  return _useNewDomain.apply(this, arguments);
} // 修改上面config对象 指定环境的域名

function _useNewDomain() {
  _useNewDomain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(env, callback) {
    var newDomain;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getNewConfig(env);

          case 2:
            newDomain = _context2.sent;

            if (newDomain) {
              setDomainConfig(env, newDomain);

              if (typeof callback === 'function') {
                callback(newDomain);
              }
            }

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _useNewDomain.apply(this, arguments);
}

export function setDomainConfig(env, domain) {
  config[env] = domain;
}
export default config;